import React from 'react';
import { View, Text, StyleSheet, SectionList, RefreshControl, Platform } from 'react-native';
import CS from '../../constants/Styles';
import Colors from '../../constants/Colors';
import { BackgroundGradient, CurrencyFormat, Button, ListSeparator, SafeAreaView, Loader } from '../../components';
import * as rtApi from '../../components/Api';
import RecentActivityItem from '../../components/Money/RecentActivityItem';
import moment from 'moment';
import { useFocusEffect } from '@react-navigation/native';
// import { formatCurrency } from '../../utils/Functions';
// import * as LocalAthentication from 'expo-local-authentication';
// import * as SecureStore from 'expo-secure-store';
import UserState from '../../src/contexts/UserState';
import { useLinkTo } from '@react-navigation/native';

export default function Money({ navigation }) {
  const [user, setUser] = React.useContext(UserState);

  let [loading, setLoading] = React.useState(false);
  let [unassignedFunds, setUnassignedFunds] = React.useState(null);
  let [recentActivity, setRecentActivity] = React.useState([]);

  // const [showMFA, setShowMFA] = React.useState(false);
  // const [MFACode, setMFACode] = React.useState(null);
  // const [MFARequired, setMFARequired] = React.useState(false);
  // React.useEffect(() => {
  //   checkMFACode();
  // }, [MFACode])

  const linkTo = useLinkTo();
  
  useFocusEffect(
    React.useCallback(() => {
      refreshRecent();
      return () => rtApi.cancel();
    }, [])
  );

  React.useEffect(() => {
    // this refreshes projects when on projects screen
    const unsubscribe = navigation.getParent().addListener('tabPress', (e) => {
      console.log('tabPress');
      // scrollRef.current.scrollTo({ x: 0, y: 0, animated: true });
      refreshRecent();
      navigation.setOptions({ title: "Money" });
    });
    return unsubscribe;
  }, [navigation]);

  // const promptWithdraw = () => {
  //   rtApi.post('money/estimate')
  //   .then(data => {
  //     console.log('money estimate', data);
  //   });
  //   console.log('prompt withdrawal', formatAmountDisplay.format('33.4'));
  //   let message = `Are you sure you want us to send you ${formatAmountDisplay.format(String(unassignedFunds))}?`;
  //   Alert.alert('Confirm', message,
  //     [
  //       {
  //         text: "Send my money",
  //         onPress: () => confirmWithdrawal(),
  //       },
  //       { text: "Cancel", onPress: () => console.log("cancel Pressed"), style: 'cancel' }
  //     ],
  //     { cancelable: false }
  //   );
  // }

  // const confirmWithdrawal = async () => {
  //   console.log('confirm ??');

  //   // let hasHardwareAsync = await LocalAthentication.hasHardwareAsync();
  //   let hasHardwareAsync = false; //testing mfa
  //   console.log('hasHardwareAsync', hasHardwareAsync);
  //   const useLocalResult = await SecureStore.getItemAsync('useLocalAuthentication');
  //   if (hasHardwareAsync && (useLocalResult && useLocalResult === 'yes')) {
  //     let supportedAuthenticationTypesAsync = await LocalAthentication.supportedAuthenticationTypesAsync();
  //     console.log('supportedAuthenticationTypesAsync', supportedAuthenticationTypesAsync);
  //     if (supportedAuthenticationTypesAsync.length !== 0) {
  //       let isEnrolledAsync = await LocalAthentication.isEnrolledAsync();
  //       console.log('isEnrolledAsync', isEnrolledAsync);
  //       if (isEnrolledAsync) {
  //         let authenticateAsync = await LocalAthentication.authenticateAsync({
  //           promptMessage: 'Confirm withdrawal of funds.'
  //         });
  //         console.log('authenticateAsync', authenticateAsync);
  //         if (authenticateAsync.success) {
  //           withdraw()
  //         }
  //       }
  //     }
  //   }else{
  //     console.log('MFA goes here');
  //     // setShowMFA(true);
  //     // setMFARequired(true);
  //     callMFA();
  //   }
  // }
  // const withdraw = () => {
  //   console.log('withdraw !!');
  // }

  // const callMFA = () => {
  //   let fd = new FormData();
  //   if (MFARequired && MFACode) {
  //     fd.append('MFA', MFACode);
  //     setMFACode(null);
  //   }
  //   rtApi.post('money', fd)
  //   .then(data => {
  //     if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
  //     if (data.MFA) {
  //       setShowMFA(true);
  //       setMFARequired(true);
  //     }else{
  //       setMFARequired(false);
  //       refreshRecent();
  //     }
  //   }).catch(err => {
  //     console.log('call mfa error', err);
  //   }).finally(() => {

  //   });
  // }
  // const checkMFACode = () => {
  //   console.log('MFACode', MFACode);
  //   if (String(MFACode).length === 6) {
  //     setShowMFA(false);
  //     if (MFARequired) {
  //       callMFA();
  //     }
  //   }
  // }

  const refreshRecent = () => {
    // alert('huh');
    setLoading(true);
    // setTimeout(() => {
    //   setRefreshingRecent(false);
    // }, 1000);
    rtApi.get('money')
    .then(data => {
      if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
      setUnassignedFunds(data.unassigned_funds);
      setRecentActivity(formatData(data.recent_activity));
      //testing
      // if(data.recent_activity.length === 0){
      //   let activity = [];
      //   for(let i=1;i<=100;i++){
      //     activity.push({ description: 'Test Money Activity', amount: Math.floor(Math.random() * 100) });
      //   }
      //   setRecentActivity(formatData({ '2020-02-03': activity, '2020-02-05': activity}));
      // }
    }).catch(err => {
      console.log('refresh recent error:', err);
    }).finally(() => {
      setLoading(false);
    });
  }

  const formatData = (data) => {
    let newData = [];
    for(let prop in data){
      newData.push({
        date: moment(prop, 'YYYY-MM-DD').format('MMM D, YYYY'),
        data: data[prop],
      })
    }
    console.log(newData);
    return newData;
  }

  const goToEstimate = () => {
    linkTo('/estimate');
  }

  const withdrawalButton = () => {
    if (unassignedFunds > 0){
      return (
        <View style={{ marginBottom: 10 }}>
          <Button text='Withdraw My Funds' onPress={() => goToEstimate} color='darkBlue' />
        </View>
      )
    }
    return null;
  }

  return (
    <SafeAreaView style={CS.safe}>
      <BackgroundGradient />
      {/* <MFAModal
        show={showMFA} 
        setMFACode={setMFACode}
        showTrusted={false}
      /> */}
      {Platform.OS === 'web' ?
        <Loader animating={loading} />
      : null}
      <View style={CS.innerContainer}>
        <View style={styles.totalContainer}>
          <Text style={styles.total}>
            <CurrencyFormat value={unassignedFunds} />
          </Text>
          <Text style={styles.totalTitle}>
            {/* {TestData.Money.totalTitle} */}
            Account Balance
          </Text>
        </View>
        
        <View style={styles.activitySection}>
          <SectionList
            sections={recentActivity}
            ListHeaderComponent={() => (
              <Text style={[CS.smallTitle, CS.lightText]}>Recent Activity</Text>
            )}
            ListFooterComponent={withdrawalButton()}
            renderSectionHeader={({ section: { date } }) => (
              <View style={styles.dateContainer}>
                <Text style={styles.date}>{date}</Text>
              </View>
            )}
            renderItem={({ item }) => <RecentActivityItem item={item} />}
            renderSectionFooter={() => (<ListSeparator />)}
            keyExtractor={(item, index) => index.toString()}
            refreshControl={<RefreshControl refreshing={loading} onRefresh={refreshRecent} colors={[Colors.yellow]} tintColor={Colors.yellow} />}
          />
        </View>
      </View>
    </SafeAreaView>
  );


}

const styles = StyleSheet.create({
  totalContainer: {
    paddingTop: 10,
    paddingBottom: 20,
    // backgroundColor:'pink'
  },
  total: {
    color: Colors.lightText,
    textAlign: 'center',
    fontSize: 66,
  },
  totalTitle: {
    color: Colors.lightBlue2,
    textAlign:'center',
    fontSize: 20,
    fontWeight: 'bold',
  },
  activitySection: {
    // flex: 1,
    // alignItems: 'flex-start',
    // justifyContent: 'flex-start',
    // backgroundColor: 'pink',
    width: '100%',
    flexGrow: 1,
    flex: 1,
  },
  dateContainer: {
    backgroundColor: Colors.blue2,
    padding: 10,
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
  },
  date: {
    color: Colors.lightBlue2,
    fontSize: 16,
  },
});
